/**
 * 侧边菜单栏状态
 * 方便在全站任意位置控制侧边菜单栏的展开与收起
 */
import { create } from 'zustand';
import { supplierAgentGlobalStore } from '@/stores/supplier-agent-global-store';

interface SiderState {
  requestListExpanded: boolean;
  supplierListExpanded: boolean;
  collapsed: boolean;
  toggleCollapsed: () => void;
  setCollapsed: (collapsed: boolean) => void;
  toggleRequestListExpanded: () => void;
  toggleSupplierListExpanded: () => void;
  setRequestListExpanded: (expanded: boolean) => void;
  setSupplierListExpanded: (expanded: boolean) => void;
}

// 本地存储的 key
const CollapKey = 'sider-collapsed';
const RequestListExpandedKey = 'sider-request-list-expanded';
const SupplierListExpandedKey = 'sider-supplier-list-expanded';

// 初始化状态
const initialCollpased = window.localStorage.getItem(CollapKey) === 'true';
const initialRequestListExpanded = window.localStorage.getItem(RequestListExpandedKey) !== 'false';
const initialSupplierListExpanded = window.localStorage.getItem(SupplierListExpandedKey) === 'true';

// 创建 store
const useSiderStore = create<SiderState>((set, get) => ({
  requestListExpanded: initialRequestListExpanded,
  supplierListExpanded: initialSupplierListExpanded,
  collapsed: initialCollpased,

  // --------------------- actions ---------------------
  setCollapsed: (collapsed: boolean) => {
    set({ collapsed });
    window.localStorage.setItem(CollapKey, String(collapsed));
    // 互斥：展开左侧菜单栏时，收起 AI Agent 侧边栏
    if (!collapsed) {
      supplierAgentGlobalStore.getState().setAgentSidebarOpen(false);
    }
  },
  toggleCollapsed: () => {
    const { setCollapsed, collapsed } = get();
    setCollapsed(!collapsed);
  },
  setRequestListExpanded: (expanded: boolean) => {
    set({ requestListExpanded: expanded });
    window.localStorage.setItem(RequestListExpandedKey, String(expanded));

    // 互斥展开
    if (expanded) {
      set({ supplierListExpanded: false });
      window.localStorage.setItem(SupplierListExpandedKey, 'false');
    }
  },
  setSupplierListExpanded: (expanded: boolean) => {
    set({ supplierListExpanded: expanded });
    window.localStorage.setItem(SupplierListExpandedKey, String(expanded));

    // 互斥展开
    if (expanded) {
      set({ requestListExpanded: false });
      window.localStorage.setItem(RequestListExpandedKey, 'false');
    }
  },
  toggleRequestListExpanded: () => {
    const { setRequestListExpanded, requestListExpanded } = get();
    setRequestListExpanded(!requestListExpanded);
  },
  toggleSupplierListExpanded: () => {
    const { setSupplierListExpanded, supplierListExpanded } = get();
    setSupplierListExpanded(!supplierListExpanded);
  },
}));

export default useSiderStore;
